import { render, staticRenderFns } from "./PatientCoachingSummaryNotes.vue?vue&type=template&id=1457968a"
import script from "./PatientCoachingSummaryNotes.vue?vue&type=script&lang=js"
export * from "./PatientCoachingSummaryNotes.vue?vue&type=script&lang=js"
import style0 from "./PatientCoachingSummaryNotes.vue?vue&type=style&index=0&id=1457968a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports